import header from '../modules/header/index';
import addScrollToTop from '../modules/addScrollToTop';
import tabPanel from '../modules/tabPanel/tabPanelIndex';
import {Apptus} from '../modules/apptus/apptus';
import asideMobileOpener from '../modules/asideMobileOpener';
import viewModeMobileHandler from '../modules/header/components/viewModeMobileHandler';
import AddToWatchlist from '../modules/profile/addToWatchList';

import "../../../scss/pages/allStyles.scss";

jQuery(function() {
  header();
  addScrollToTop();
  tabPanel();
  asideMobileOpener();
  viewModeMobileHandler();


  if (window.innerWidth <= 767) {
    $('#sidebar').appendTo('.mobile-filter-block');
    $('.ctrl-container.search-panel').prependTo('.drop-container');
  } else {
    $('#sidebar').prependTo('#twocolumns');
    if ($('#sidebar .ctrl-container.search-panel').length) {
      $('.ctrl-container.search-panel').insertAfter('.tab-panel');
    }
  }

  $(".btn-back").not(".no-history").on("click", function () {
    history.back();
  });

  $(window).on('click', (e) => {
    let target = e.target;
    var targetParent = $(target).parent();
    if(target.matches('.update-apptus-func') ) {
        Apptus.NotifyClick($(target).attr('data-apptus'))
    }
    if(targetParent.hasClass('update-apptus-func') ) {
        Apptus.NotifyClick($(targetParent).attr('data-apptus'))
    }
  })
})